export const ZERO = 0;
export const SINGLE = 1;
export const DOUBLE = 2;
export const TRIPLE = 3;
export const QUADRUPLE = 4;
export const QUINTUPLE = 5;
export const SEXTUPLE = 6;
export const SEPTUPLE = 7;
export const OCTUPLE = 8;
export const NONUPLE = 9;
export const DECUPLE = 10;
export const UNDECUPLE = 11;
export const DUODECUPLE = 12;
export const TREDECUPLE = 13;
export const QUATTUORDECUPLE = 14;
export const QUINDECUPLE = 15;
export const SEXDECUPLE = 16;
export const SEPTENDECUPLE = 17;
export const OCTODECUPLE = 18;
export const NOVEMDECUPLE = 19;
export const VIGINTUPLE = 20;
export const CENTUPLE = 100;
export const CHILIUPLE = 1000;
export const PARSE_INT_RADIX = 10;
export const JSON_STRINGIFY_INDENTATION = 4;
export const JSON_STRINGIFY_INDENTATION_SMALL = 2;
export const DECILE = 0.1;
export const DOUBLE_DECILE = 0.2;
export const TRIPLE_DECILE = 0.3;
export const QUADRUPLE_DECILE = 0.4;
export const QUINTUPLE_DECILE = 0.5;
export const SEXTUPLE_DECILE = 0.6;
export const SEPTUPLE_DECILE = 0.7;
export const OCTUPLE_DECILE = 0.8;
export const NONUPLE_DECILE = 0.9;
export const SESQUIPLE = 1.5;
export const SESQUIDOUBLE = 2.5;
